import { Inject, Injectable } from '@angular/core';
import { CurrentUserStorage } from '@lms/shared/storages';
import { Environment, ENVIRONMENT_TOKEN, TypeformSurveyIdEnum } from '@lms/shared/models';
import { TypeformSurveysService } from '@lms/shared/services/api-services';

const TYPEFORM_SURVEY_URL = 'https://corporatefinanceinstitute.typeform.com/to/';

@Injectable({
  providedIn: 'root',
})
export class TypeformLinkService {
  private isLoading = false;

  constructor(
    @Inject(ENVIRONMENT_TOKEN) private environment: Environment,
    private typeformSurveysService: TypeformSurveysService,
    private currentUserStorage: CurrentUserStorage,
  ) {}

  public openLink(surveyType: TypeformSurveyIdEnum = TypeformSurveyIdEnum.WELCOME, isBlank = false): void {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.typeformSurveysService.getTypeformSurvey(surveyType).subscribe(typeform => {
      this.isLoading = false;

      if (!typeform?.shareId) {
        return;
      }

      this.openWindow(surveyType, typeform.shareId, isBlank);
    });
  }

  private openWindow(surveyType: TypeformSurveyIdEnum, shareId: string, isBlank: boolean): void {
    const user = this.currentUserStorage.getCurrentUser();
    if (!user) {
      return;
    }

    const url = this.buildSurveyUrl(surveyType, shareId, user);
    window.open(url, isBlank ? '_blank' : '_self');
  }

  private buildSurveyUrl(surveyType: TypeformSurveyIdEnum, shareId: string, user: any): string {
    const baseUrl = `${TYPEFORM_SURVEY_URL}${shareId}`;
    const dashboardUrl = new URL(this.environment.dashboardPanelUrl);
    const commonParams = {
      user: user.id,
      survey: surveyType,
    };

    const surveyParams: Record<TypeformSurveyIdEnum, Record<string, string>> = {
      [TypeformSurveyIdEnum.WELCOME]: {
        ...commonParams,
        email: user.email,
        user_id: user.id,
      },
      [TypeformSurveyIdEnum.IBISWORLS]: {
        ...commonParams,
      },
      [TypeformSurveyIdEnum.CANCELLATION]: {
        ...commonParams,
        email: user.email,
        firstname: user.firstname,
        lastname: user.lastname,
      },
      [TypeformSurveyIdEnum.PITCHBOOK]: {
        ...commonParams,
      },
    };

    const params = surveyParams[surveyType];
    if (!params) {
      return baseUrl;
    }

    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');

    if (surveyType === TypeformSurveyIdEnum.WELCOME) {
      return `${baseUrl}?typeform-source=${dashboardUrl.hostname}#${queryString}`;
    }

    return `${baseUrl}#${queryString}`;
  }
}
